// extracted by mini-css-extract-plugin
export default {"errorPage":"Error_errorPage__UOuKW"};